import { createAsyncThunk } from '@reduxjs/toolkit';
import rootAxios from 'requests/rootAxios';

export const fetchBranchFeedback = createAsyncThunk(
  'branchFeedback/fetchBranchFeedback',
  async (batchId, { rejectWithValue }) => {
    try {
      const response = await rootAxios.post('/user/getBranchFeedback', {
        batchId: batchId,
      });
      return response.data.data.data[0];
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      // It's possible feedback doesn't exist yet, so a console log may be better than a toast
      console.error('Error fetching branch feedback:', errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);
